import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CottageIcon(props: IconProps) {
    return <Icon {...props} iconKey={"cottage"}/>
}
